<div id="suggest-title" class="m-3">

    <h1>Recomendar títulos para enunciados</h1>

    <div id="lesson-source">
        <label for="course-units" class="d-block" *ngIf="courseUnits">
            <p class="fw-bold">Unidad:</p>
            <select name="course-units" id="course-units" [(ngModel)]="selectedUnit"
                (ngModelChange)="selectUnit($event)">
                <option disabled selected value="-1">Seleccione una unidad...</option>
                <option *ngFor="let unit of courseUnits" value="{{ unit.id }}">
                    {{ unit.name }}
                </option>
            </select>
        </label>

        <label for="units-lessons" class="d-block" *ngIf="unitLessons">
            <p class="fw-bold">Lección:</p>
            <select name="unit-lessons" id="unit-lessons" [(ngModel)]="selectedLesson"
                (ngModelChange)="selectLesson($event)">
                <option disabled selected value="-1">Seleccione una lección...</option>
                <option *ngFor="let lesson of unitLessons" value="{{ lesson.id }}">
                    {{ lesson.name }}
                </option>
            </select>
        </label>

        <label for="lesson-headings" class="d-block" *ngIf="lessonHeadings">
            <p class="fw-bold">Enunciado:</p>
            <select name="lesson-headings" id="lesson-headings" [(ngModel)]="selectedHeading"
                (ngModelChange)="selectHeading($event)">
                <option disabled selected value="-1">Seleccione un enunciado...</option>
                <option *ngFor="let heading of lessonHeadings" [value]="heading.id">
                    {{ heading.name }}
                </option>
            </select>
        </label>
    </div>

    <div id="suggest-title-options">

        <label for="titleWordNum" class="d-block">
            <p class="fw-bold">Número de palabras por título:</p>
            <input type="number" min="5" [(ngModel)]="titleWords">
        </label>

        <label for="numTitles" class="d-block">
            <p class="fw-bold">Número de títulos a mostrar:</p>
            <input type="number" min="3" [(ngModel)]="numTitles">
        </label>

    </div>

    <div id="suggest-title-buttons" class="row">
        <button class="btn btn-primary m-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
        <button class="btn btn-success m-3" [attr.disabled]="suggestTitleBtnDisabled ? 'disabled' : null"
            (click)="suggestTitle()">
            <i class="fas fa-align-center"></i>
            <span>Recomendar títulos</span>
        </button>
    </div>

    <div id="suggest-title-result" class="form-group text-center">
        <div id="suggest-title-loading" *ngIf="suggestTitleLoading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere, por favor...</span>
        </div>
        <div id="suggest-title-error" class="text-danger" *ngIf="suggestTitleError">
            <i class="fa fa-times"></i>
            <!-- <span>{{ suggestTitleResultMsg }}</span> -->
            <span>Hubo un error, no se han generado títulos. Por favor, inténtelo de nuevo con otros parámetros.</span>
        </div>
        <div id="suggest-title-success" class="text-success" *ngIf="suggestTitleSuccess">
            <i class="fa fa-check"></i>
            <!-- <span>{{ suggestTitleResultMsg }}</span> -->
            <span>{{ suggestTitleResultMsg }}</span>
        </div>
    </div>

    <div id="suggested-titles" *ngIf="suggestTitleSuccess">
        <p class="fw-bold">Títulos generados:</p>
        <ul>
            <li *ngFor="let title of suggestedTitles">
                <label class="d-block">
                    <input type="radio" name="suggestedTitles" (click)="selectedTitle = title; updateHeadingTitleBtnDisabled = false;">
                    <span class="ms-3">{{ title }}</span>
                </label>
            </li>
        </ul>

        <p class="fw-bold">Título seleccionado:</p>
        <input type="text" size="100" [(ngModel)]="selectedTitle" (ngModelChange)="changeSelectedTitle()">
    </div>

    <div id="update-heading-title-buttons" *ngIf="suggestTitleSuccess">
        <button class="btn btn-primary m-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
        <button class="btn btn-success m-3" [attr.disabled]="updateHeadingTitleBtnDisabled ? 'disabled' : null" (click)="updateHeadingTitle()">
            <i class="fas fa-save"></i>
            <span>Actualizar título de enunciado</span>
        </button>
    </div>

    <div id="update-heading-title-result" class="form-group text-center">
        <div id="update-heading-title-loading" *ngIf="updateHeadingTitleLoading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere, por favor...</span>
        </div>
        <div id="update-heading-title-error" class="text-danger" *ngIf="updateHeadingTitleError">
            <i class="fa fa-times"></i>
            <span>Hubo un error, no se ha podido actualizar el título del enunciado. Por favor, inténtelo de nuevo.</span>
        </div>
        <div id="update-heading-title-success" class="text-success" *ngIf="updateHeadingTitleSuccess">
            <i class="fa fa-check"></i>
            <span>El título del enunciado se ha actualizado correctamente.</span>
        </div>
    </div>

</div>